import { createContext } from 'react';
import { UserProfileViewContextProps } from "context/userProfile/UserProfileViewContextProps";

const initialState: UserProfileViewContextProps = {
    getProfilePending: false,
    refreshProfile: async () => {},
    user: null,
    isProfileOfLoggedUser: false,
}

export const UserProfileViewContext = createContext<UserProfileViewContextProps>(initialState);
